import { from as observableFrom, Observable } from 'rxjs';
import { Injectable, Injector } from '@angular/core';
import { Command } from '../../../core/model/command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { leaseAgreementCommand } from '../../command/lease-agreement.command';
import { Router } from '@angular/router';
import { ComponentMessageDispatcher } from '../../../core/service/component-message-dispather.service';
import { Location } from '@angular/common';
import { NavigationService } from '../../../core/service/navigation.service';
import { Contract } from '../../model/contract';
import { LeaseAgreementStatus } from '../../model/const/enums';
import { MessageService } from '../../../core/service/message.service';

@Injectable()
export class TerminateContractCommandHandler implements ICommandHandler {
  constructor(
    private _navigationService: NavigationService,
    private _messageService: MessageService
  ) {}

  canExecute(command: Command): boolean {
    if (command instanceof Command && command.context instanceof Contract) {
      if (command.id !== leaseAgreementCommand.terminate) {
        return false;
      }

      if (command.context.status !== LeaseAgreementStatus.Coming && command.context.status !== LeaseAgreementStatus.Valid) {
        this._messageService.showMessage('ERROR.TERMINATE_NOT_VALID_LEASE_AGREEMENT');
        return false;
      }

      return true;
    }

    return false;
  }

  execute(command: Command): Observable<boolean> {
    if (command instanceof Command) {
      return observableFrom(this._navigationService.navigateChild([command.context.id, 'terminate-leaseagreement']));
    }
  }
}
